import React from "react";
import styled from "styled-components/macro";
import { Button } from "@material-ui/core";

const PopUpItem = ({
  item: { image, title, model, category, link },
  quantity,
}) => {
  return (
    <Wrapper>
      <div style={{ display: "flex", position: "relative" }}>
        <img
          style={{ objectFit: "contain" }}
          width={111}
          height={111}
          src={image}
          alt={"Item"}
        />
        <TextArea>
          <Title>{title}</Title>
          {model && <Text>{model}</Text>}
          <Text>{`Quantity: ${quantity.count}`}</Text>
          <Text>{category}</Text>
        </TextArea>
      </div>
      <div
        style={{
          display: "flex",
          position: "relative",
          width: "100%",
          justifyContent: "space-around",
        }}
      >
        <Button
          variant="outlined"
          style={{ marginTop: "10px", color: "#4b4b4b" }}
          onClick={() => window.open(link, "_blank")}
        >
          Learn More
        </Button>
        <div style={{ width: "10px" }} />
        <Button
          variant="outlined"
          style={{ marginTop: "10px", color: "#4b4b4b" }}
          onClick={() => {}}
        >
          Replace item
        </Button>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  justify-content: center;
  box-shadow: 2px 3px 15px 4px rgba(0, 0, 0, 0.3);
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 18px;
  background-color: white;
  padding: 15px;
`;

const TextArea = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-left: 10px;
`;

const Title = styled.div`
  color: #4b4b4b;
  font-size: 18px;
  font-weight: bolder;
  line-height: 1.5;
  font-family: Manrope, serif;
  margin-bottom: 5px;
`;

const Text = styled.div`
  color: #4b4b4b;
  font-size: 15px;
  line-height: 1.5;
  font-family: Manrope, serif;
`;

export { PopUpItem };
